const hosts = {
  CTL_AUTHENTICATOR_SERVER: 'http://localhost:8501',
  CTL_DATA_SERVER: 'http://localhost:8500',
  CTL_IMAGE_SERVER: 'http://localhost:8503',
  CTL_ELASTIC_SEARCH: '',
  AIPF_PORTAL_DOMAIN: 'http://localhost:3000',
} as const;

export default hosts;
